import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  ModalData,
  ModalRef,
  TableColumnItem,
  TableColumnTypeEnum,
  TableComponent,
} from '@ui-lib/components';
import { TranslateModule } from '@ngx-translate/core';
import { ScanByIdContainer } from '../../scanner.model';

interface ContainersModalData {
  containers: ScanByIdContainer[];
}

@Component({
  selector: 'mon-containers-modal',
  templateUrl: './containers-modal.component.html',
  styleUrl: './containers-modal.component.scss',
  imports: [CommonModule, TranslateModule, TableComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContainersModalComponent extends ModalData<ContainersModalData> {
  private readonly modalRef = inject(ModalRef<void>);

  protected readonly CONTAINER_COLUMNS: TableColumnItem[] = [
    {
      propName: 'name',
      captionTranslateKey: 'monitoring.scanner.details.containers-modal.name',
      type: TableColumnTypeEnum.Text,
    },
    {
      propName: 'ipRange',
      captionTranslateKey: 'monitoring.scanner.details.containers-modal.ip-range',
      type: TableColumnTypeEnum.Text,
    },
  ];

  protected readonly containers = this.modalData.containers;

  public asContainer(row: unknown): ScanByIdContainer {
    return row as ScanByIdContainer;
  }

  public close(): void {
    this.modalRef.close();
  }
}
